<template>
    <v-tab-item :value="tabCode" :transition="false">
        <template #default>
            <v-card flat>
                <v-card-text class="step-container" :class="'step-container__'+tabCode">
                    <slot name="default">
                        <h2 class="page-title page-title__primary" v-html="title"></h2>
                        <slot name="description">
                            <p v-if="description" v-html="description"></p>
                        </slot>
                        <slot name="content" :data="value"></slot>
                        <slot name="error">
                            <v-alert type="error" color="red" v-html="error" v-if="error" class="mt-4"></v-alert>
                        </slot>
                        <slot name="files" v-if="showFiles">
                            <div class="mb-8 mt-4">
                                <v-chip v-for="file in files"
                                        color="primary"
                                        class="mr-2"
                                        outlined
                                        small
                                        close
                                        :key="file.name"
                                        @click:close="removeFile(file)"
                                >{{file.name}}</v-chip>
                            </div>
                        </slot>
                        <slot name="upload" :data="value" v-if="enableUpload">
                            <v-btn color="primary" elevation="0" :loading="isUploading"
                                   class="mr-4"
                                   @click="showSelectFileDialog"
                            >{{hasData ? (showFiles ? 'Добавить данные' : 'Заменить данные') : 'Загрузить данные'}}</v-btn>
                            <v-btn v-if="hasData && showFiles" color="primary" elevation="0" @click="approve">
                                Подтвердить
                            </v-btn>
                            <input v-if="single"
                                   ref="uploader"
                                   class="d-none"
                                   type="file"
                                   @change="onFileChanged"
                            >
                            <input v-else
                                   ref="uploader"
                                   class="d-none"
                                   type="file"
                                   multiple="multiple"
                                   @change="onFileChanged"
                            >
                        </slot>
                        <slot name="extra" :data="value"></slot>
                    </slot>
                </v-card-text>
            </v-card>
        </template>
    </v-tab-item>
</template>

<script>
export default {
    props: ['value', 'title', 'description', 'inputHasData', 'error', 'single', 'isValid', 'tabCode', 'isUploading', 'enableUpload', 'showFiles'],
    data() {
        return {
            isSelecting: false,
            files: this.value || [],
        }
    },
    watch: {
        value() {
            this.files = this.value || [];
        }
    },
    methods: {
        getFileNames(files) {
            return files.map(file => file.name).join(', ');
        },
        showSelectFileDialog() {
            this.isSelecting = true;

            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });

            this.$refs.uploader.click();
        },
        async onFileChanged(e) {
            if (!this.showFiles) {
                this.files = [];
            }

            for (let file of e.target.files) {
                let fileWithData = await this.readFile(file);
                this.files.push(fileWithData);
            }

            if (this.$refs.uploader) {
                this.$refs.uploader.files = null;
            }

            if (!this.showFiles) {
                this.approve();
            }
        },
        removeFile(file) {
            let index = this.files.indexOf(file);
            if (index > -1) {
                this.files.splice(index, 1);
            }
        },
        approve() {
            if (this.files && this.files.length > 0) {
                this.$emit('input', this.files);
            }
        },
        async loadToBrowser(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async readFile(file) {
            if (!file) {
                return;
            }

            file.buffer = await this.loadToBrowser(file);
            return file;
        },
    },
    computed: {
        hasData() {
            return Boolean(this.value) || Boolean(this.inputHasData) || this.files?.length > 0;
        },
        everythingValid() {
            if (typeof (this.isValid) === 'boolean') {
                return this.isValid;
            }

            return this.hasData && !this.error;
        }
    }
}
</script>


<style>
    .step-container {
        position: relative;
    }
</style>
